module.exports = __webpack_public_path__ + "static/media/rsmBlue1QuestionThingy.b7d34e23.svg";